import React from 'react';

import CloseIcon from 'icons/ic-close.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import SidePanel from 'components/application/SidePanel';

import ProjectsAnalyticsDivisionsFilter from 'components/projectsAnalytics/components/ProjectsAnalyticsDivisionsFilter';

export default function ProjectsAnalyticsFiltersSidePanel({
  filters,
  isOpen,
  onClose,
  onFilterChange,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectsAnalytics.components.ProjectsAnalyticsFiltersSidePanel',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <SidePanel
      bodyContent={
        <div className='tw-border-0 tw-border-b-1 tw-border-solid tw-border-grey-100 tw-p-5'>
          <ProjectsAnalyticsDivisionsFilter
            divisionIdsFilter={filters.divisionIds}
            onChange={(value) => {
              onFilterChange({ filter: 'divisionIds', value });
            }}
          />
        </div>
      }
      closeCallback={onClose}
      color='tertiary'
      headerContent={
        <div className='tw-flex tw-items-center tw-justify-between'>
          <h1 className='tw-m-0 tw-text-xl tw-font-semibold tw-tracking-tight tw-text-grey-900'>
            {i18nT('title')}
          </h1>
          <button
            className='tw-h-7 tw-w-7 tw-rounded-lg tw-border-0 tw-bg-white tw-p-0 [&_polygon]:tw-fill-grey-500'
            onClick={onClose}
          >
            <CloseIcon height={28} width={28} />
            <span className='tw-sr-only'>{i18nTShared('close')}</span>
          </button>
        </div>
      }
      isOpen={isOpen}
    />
  );
}

ProjectsAnalyticsFiltersSidePanel.propTypes = {
  filters: PropTypes.shape({
    divisionIds: PropTypes.instanceOf(Set).isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
};
